import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'

import {
    fecthQuoteList,
    fecthPoliciesList,
    bindQuoteVariation,
    confirmEditQuote
} from '../../../actions'

import Clients from '../../../components/pages/Clients/Clients'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        clientList: state.clientList,
        step05: state.quote.step05,
    }
}

export default connect(mapStateToProps, {
    fecthQuoteList,
    fecthPoliciesList,
    bindQuoteVariation,
    confirmEditQuote,
})(Clients)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Clients/Clients.tsx